export interface OutboundCampaignAttribution {
  source: string;
  medium: string;
  campaign: string;
  content: string;
}

export interface SponsorshipAttribution {
  source: string;
  content: string;
}

const UTM_FIELDS = {
  source: 'utm_source',
  medium: 'utm_medium',
  campaign: 'utm_campaign',
  content: 'utm_content',
} as const;

export function appendOutboundCampaignAttribution(
  destinationUrl: string,
  attribution: OutboundCampaignAttribution
): string {
  try {
    const url = new URL(destinationUrl);

    for (const [field, queryParam] of Object.entries(UTM_FIELDS)) {
      if (!url.searchParams.has(queryParam)) {
        url.searchParams.set(queryParam, attribution[field as keyof OutboundCampaignAttribution]);
      }
    }

    return url.toString();
  } catch {
    return destinationUrl;
  }
}

function normalizeCampaignValue(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}

function normalizeSource(sourceContext: string | null | undefined): string {
  const value = sourceContext?.trim();
  if (!value) return 'atrivial';

  try {
    const url = new URL(value.includes('://') ? value : `https://${value}`);
    return url.hostname.toLowerCase().replace(/^www\./, '') || 'atrivial';
  } catch {
    return normalizeCampaignValue(value) || 'atrivial';
  }
}

export function buildSponsorshipAttribution(input: {
  sourceContext?: string | null;
  quizSlug?: string | null;
  editionCreatedAt?: string | null;
}): SponsorshipAttribution {
  const quiz = normalizeCampaignValue(input.quizSlug || 'quiz') || 'quiz';
  const editionDate = input.editionCreatedAt ? new Date(input.editionCreatedAt) : null;
  const date =
    editionDate && !Number.isNaN(editionDate.getTime())
      ? editionDate.toISOString().slice(0, 10).replace(/-/g, '_')
      : null;

  return {
    source: normalizeSource(input.sourceContext),
    content: [quiz, date, 'end_screen'].filter(Boolean).join('_'),
  };
}
